<template>
	<v-expansion-panel>
		<v-expansion-panel-header style="min-height: 40px">
			{{ getItemName(node)}}
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<div class="d-flex flex-wrap pb-1">
				<!-- last item -->
				<button
					v-if="!node.children"
					v-ripple
					:class="[
						...bindButtonClasses,
						getItemName(node).length > 16 ? 'text-small' : 'text-body-2'
					]"
					:disabled="disabledButtons"
					:style="{
						width: $vuetify.breakpoint.lgAndUp ? '30%' : '50%',
						height: $vuetify.breakpoint.lgAndUp ? '55px' : '40px'
					}"
					@click="$emit('select-item', node)"
				>
					{{ typeof itemText === "string" ? node[itemText] : itemText(node) }}
				</button>
				
				<!-- children -->
				<button
					v-for="child in (node.children || []).filter(c => !c.children || c.children.length === 0)"
					:key="child.id"
					v-ripple
					:class="[
						...bindButtonClasses,
						getItemName(node).length > 16 ? 'text-small' : 'text-body-2'
					]"
					:disabled="disabledButtons"
					:style="{
						width: $vuetify.breakpoint.lgAndUp ? '30%' : '50%',
						height: $vuetify.breakpoint.lgAndUp ? '55px' : '40px'
					}"
					@click="$emit('select-item', child)"
				>
					{{ getItemName(child) }}
				</button>

				<!-- tree -->
				<bee-expander-tree
					:item-text="itemText"
					:item-class="itemClass"
					:nodes="(node.children || []).filter(c => c.children && c.children.length > 0)"
					:level="level + 1"
					:show-divider="showDivider"
					:disabled-buttons="disabledButtons"
					@select-item="e => $emit('select-item', e)"
				/>
			</div>
		</v-expansion-panel-content>
		<v-divider
			v-if="showDivider"
			:style="`margin-${$i18n.locale === 'ar' ? 'left' : 'right'}: ${(level-1) * 20}px`"
		/>
	</v-expansion-panel>
</template>

<script>
export default {
	name: 'BeeExpanderTreeNode',

	props: {
		node: { type: Object },
		level: { type: Number, default: 1 },
		showDivider: { type: Boolean, default: false },
		disabledButtons: { type: Boolean, default: false },
		itemClass: { type: String },
		itemText: { type: [String, Function], default: 'name' },
	},

	computed: {
		bindButtonClasses() {
			return [
				'd-flex justify-center align-center text-center text-capitalize grey lighten-3 rounded-medium px-2 elevation-2 font-weight-bold mx-1 mb-1',
				this.itemClass,
				{ 'elevation-0 grey--text': this.disabledButtons },
			]
		}
	},

	methods: {
		getItemName(node) {
			return typeof this.itemText === 'string' ? node[this.itemText] : (this.itemText(node) || '');
		}
	},

	beforeCreate() {
		this.$options.components.VExpanderTree = require('./BeeExpanderTree.vue').default;
	},
};
</script>

<style>
</style>